import styled from "styled-components";

export const Background = styled.div`
	position: fixed;
	width: 100%;
	height: 100dvh;
	background: rgba(0, 0, 0, 0.8);
	z-index: 999;
	display: ${(props) => (props.isOpen ? 'flex' : 'none')};
	justify-content: center;
	align-items: center;
	padding: 20px;
	box-sizing: border-box;
	overflow: hidden;
`;

export const FormContainer = styled.div`
    position: relative;
	width: 100%;
    height: fit-content;
    max-height: 80%;
	max-width: 400px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 4px 10px rgba(20, 20, 20, 0.5);
	z-index: 1000;
    overflow-y: scroll;
    overflow-x: hidden;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    div {
        margin-left: 20px;
        display: flex;
        
        span {
            margin-left: 10px;
        }
    }
`;

export const ButtonCloseForm = styled.button`
	position: absolute;
	top: 20px;
	right: 20px;
	background: none;
	border: none;
	font-size: 18px;
	cursor: pointer;
	color: #333;

	&:hover {
		color: #ff0000;
	}
`;

export const TitleForm = styled.span`
    width: 100%;
	text-align: center;
	color: #333;
	margin-bottom: 20px;
	font-size: 20px;
`;

export const Form = styled.div`
	display: flex;
    width: 100%;
	flex-direction: column;
	gap: 20px;
    margin-bottom: 20px;
`;

export const Field = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
`;

export const Input = styled.input`
    width: 90%;
    padding: 10px;
    font-size: 16px;
    border-radius: 4px;
    background-color: transparent;
    outline: none;
    border: none;
    border: 1px solid #ccc;
    transition: all 0.3s;

    &:focus {
        border-color: #007bff;
        color: #007bff;
    }

    &:not(:placeholder-shown) + label,
    &:focus + label {
        top: -10px;
        left: 5px;
        font-size: 12px;
        color: #2c313590;
        background-color: #fff;
        padding: 0 5px;
    }
`;

export const Label = styled.label`
    position: absolute;
    top: 50%;
    left: 10px;
    font-size: 16px;
    color: #aaa;
    transition: all 0.3s;
    pointer-events: none;
    background-color: transparent;
    padding: 0 5px;
`;

export const Buttons = styled.div`
    display: flex;
    width: 100%;
    margin: auto;
    margin-left: 10px;
`;

export const Button = styled.button`
    background-color: #FEC108;
    color: #fafbfc;
    height: 30px;
    width: 33%;
    margin-right: 10px;
    border-radius: 12px;

    &:hover {
        background-color: #FEC10890;
    }
`;

export const ErrorText = styled.p`
    color: red;
    font-size: 14px;
    margin: 0px 0px 20px 0px;
`;